import { useEffect } from "react";
import styled from "styled-components";
import { Z_INDEX } from "../constants/zIndex";

interface ModalTemplateProps {
  children: React.ReactNode;
}

const ModalTemplate = ({ children }: ModalTemplateProps) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return <Layout>{children}</Layout>;
};

export default ModalTemplate;

const Layout = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(0, 0, 0, 0.8);
  z-index: ${Z_INDEX.MODAL};
`;
